import type { InfosecLevelOption } from "~/ai-chat/ui/chat-save-resource-card";
import { useGetPlatformInfosecSettings } from "~/api/useInfosecLevels";
import { useAllowedInfosecLevels, useInfosecFeatureEnabled } from "~/hooks";

// Resolves whether a chat save can be classified, the levels the user may pick, and the platform default
// a save gets when they pick nothing (what a regular upload gets too). Shared by the save card, the save
// dialog and the share modal. `infosecEnabled === undefined` means the platform setting hasn't resolved
// yet — callers keep saving blocked then so the level picker is on screen before the save goes out.
export function useChatSaveInfosec() {
  const featureEnabled = useInfosecFeatureEnabled();
  const platformInfosec = useGetPlatformInfosecSettings();
  const infosecLevels = useAllowedInfosecLevels(undefined, { enabled: featureEnabled });

  // Off feature shell ⇒ definitively false (no classification concept); on an infosec deployment, undefined
  // while the setting resolves keeps saving blocked.
  const infosecEnabled = featureEnabled ? platformInfosec.data?.enabled : false;
  const defaultInfosecLevel: InfosecLevelOption | null = featureEnabled
    ? (platformInfosec.data?.defaultResourceLevel ?? null)
    : null;

  return { infosecEnabled, infosecLevels, defaultInfosecLevel };
}
